export const SET_POSTS = "SET_POSTS";
export const SET_STORIES = "SET_STORIES";
export const SET_GETTING_POSTS = "SET_GETTING_POSTS";
export const SET_MY_POSTS = "SET_MY_POSTS";
export const SET_MY_EVENTS = "SET_MY_EVENTS";
